var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1 text-right"},[_c('button',{staticClass:"ml-3 btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.onNew()}}},[_vm._v(_vm._s(_vm.$t('신규')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }